export default {
  state: {
    combination: {
      data: '',
    },
    confirmationPhoto: {
      savedKeyRemovePhoto: -1,
    },
    report: {
      isOpen: false,
      type: '',
      newsfeedId: '',
      isLoadingFinish: true,
    },
    userPhotos: {
      initialIndexSlide: 0,
      isOpen: false,
      data: '',
      totalUserPhoto: 0,
    },
    discardAddProduct: {
      data: '',
    },
    editReview: {
      data: '',
    },
    productExisted: {
      data: '',
    },
    loginPage: {
      data: 0,
    },
    isModalShow: {
      verifyCode: false,
      otpCode: false,
      changeNumber: false,
      forgotPassword: false,
      combination: false,
      confirmationPublish: false,
      discard: false,
      confirmationPhoto: false,
      confirmationDiscardPhoto: false,
      confirmationEdit: false,
      editReview: false,
      filterSearch: false,
      filterBrand: false,
      filterCategory: false,
      brands: false,
      productExisted: false,
      selectCategory: false,
      productCombination: false,
      discardAddProduct: false,
      discardModal: false,
      publishedReview: false,
      tellFriends: false,
      confirmBP: false,
      reviewError: false,
      privacyPolicy: false,
      tnc: false,
      filterV2: false,
      overseasPhone: false,
      offlineRegistration: false,
      tncPhoto: false,
      shareExperience: false,
    },
    productData: '',
    reviewErrorMessage: '',
    isSeeAll: false,
  },
  mutations: {
    setSavedKeyRemovePhoto(state, key) {
      state.confirmationPhoto.savedKeyRemovePhoto = key;
    },
    setReviewDetails(state, value) {
      state.editReview.data.details = value;
    },
    setReviewTags(state, value) {
      state.editReview.data.tags = value;
    },
    setReviewDurationUsage(state, value) {
      state.editReview.data.duration_of_used = value;
    },
    setReviewIsRepurchase(state, value) {
      state.editReview.data.is_repurchase = value;
    },
    setReviewIsRecommended(state, value) {
      state.editReview.data.is_recommended = value;
    },
    setReviewRatingType(state, { name, value }) {
      state.editReview.data.ratingTypes[name].value = value;
    },
    setDataGlobalUserPhotos(state, data) {
      state.userPhotos.data = data;
    },
    setInitialIndexSlideGlobalUserPhotos(state, indexSlide) {
      state.userPhotos.initialIndexSlide = indexSlide;
    },
    setTotalUserPhotoGlobalUserPhotos(state, total) {
      state.userPhotos.totalUserPhoto = total;
    },
    setNewsfeedIdOfModalReport(state, newVal) {
      state.report.newsfeedId = newVal;
    },
    setTypeOfModalReport(state, newType) {
      state.report.type = newType;
    },
    setOpenModal(state, { stateName, newVal }) {
      state[stateName].isOpen = newVal;
    },
    setDataModal(state, { modalName, value }) {
      state[modalName].data = value;
    },
    setLoadingModal(state, { stateName, newVal }) {
      state[stateName].isLoadingFinish = newVal;
    },
    toggleModalGlobalState(state, { modalName }) {
      if (state.isModalShow[modalName]) {
        state.isModalShow[modalName] = false;
        $SO('body').removeClass('no-scroll');
      } else {
        state.isModalShow[modalName] = true;
        $SO('body').addClass('no-scroll');
      }
    },
    setProductData(state, data) {
      state.productData = data;
    },
    setDataModalEditReview(state, data) {
      const ratingTypes = {};
      const lisRatingTypes = [];
      $SO.each(data, (property_name, value) => {
        if (/star_/.test(property_name) && value) {
          ratingTypes[property_name] = { value: value };
          lisRatingTypes.push(property_name);
        }
      });

      this._vm.$set(data, 'ratingTypes', ratingTypes);
      data.lisRatingTypes = lisRatingTypes;
      state.editReview.data = data;
    },
    setDataGlobalCombination(state, data) {
      const combinations = [];
      if (data.combinations && data.combinations.length) {
        data.combinations.forEach((combination, key) => {
          if (combination.attributes && Object.keys(combination.attributes).length) {
            let combination_group_name_html = '';
            for (const attribute in combination.attributes) {
              let attribute_name;
              if (combination.attributes.hasOwnProperty(attribute)) {
                if (
                  attribute !== 'non_specify' &&
                  (combination.attributes[attribute].my_sociolla_sql_id ||
                    combination.attributes[attribute].my_soco_sql_id)
                ) {
                  combination_group_name_html = combination_group_name_html
                    ? combination_group_name_html + ', '
                    : combination_group_name_html;
                  let formatedData;

                  if (
                    combination.attributes[attribute].value &&
                    combination.attributes[attribute].value.search('#') !== -1 &&
                    combination.attributes[attribute].value.length <= 7
                  ) {
                    formatedData = `<button style="background:${
                      combination.attributes[attribute].value
                    };border:1px solid #f5f5f5;" class="shade-img"> </button> ${attribute.replace(
                      /(?:^|\s)\S/g,
                      function (a) {
                        return a.toUpperCase();
                      }
                    )}`;
                  } else {
                    formatedData = `<img src="${
                      combination.attributes[attribute].value
                    }" class="shade-img" onerror="this.src='/assets/img/dummy-combination.png';" alt="SOCO" /> ${attribute.replace(
                      /(?:^|\s)\S/g,
                      function (a) {
                        return a.toUpperCase();
                      }
                    )}`;
                  }
                  attribute_name =
                    attribute === 'shade'
                      ? formatedData
                      : attribute.replace(/(?:^|\s)\S/g, function (a) {
                          return a.toUpperCase();
                        });
                  combination_group_name_html += `${attribute_name} - ${combination.attributes[attribute].name}`;
                }
              }
            }

            if (combination_group_name_html) {
              let name_html = combination_group_name_html;
              const explode_combination_to_array = name_html.split(', ');
              if (explode_combination_to_array.length > 1 && explode_combination_to_array[1].indexOf('shade')) {
                name_html =
                  explode_combination_to_array[0] +
                  ', ' +
                  explode_combination_to_array[1] +
                  ', ' +
                  explode_combination_to_array[2];
              }

              combinations.push({
                name_html: name_html,
                name: name_html.trim(),
                images: combination.images,
                _id: combination['_id'],
                is_active_in_review: combination.is_active_in_review,
                is_reviewed: combination.is_reviewed,
                is_verified_purchase: combination.is_verified_purchase,
              });
            }
          }
        });
      }
      data.list_combinations = combinations;
      data.currentCombination = data.default_combination ? data.default_combination : data.combinations;

      state.combination.data = data;
    },
    setReviewErrorMessage(state, message) {
      state.reviewErrorMessage = String(message);
    },
    setSeeAll(state, message) {
      state.isSeeAll = message;
    },
  },
  actions: {
    setDataModalEditReview({ commit, dispatch }, data) {
      commit('setDataModalEditReview', data);
      $SO.each(data.images, (key, image) => {
        commit('addDataProductShot', { fileImageBase64: image.name, caption: image.description }); // from module writeReview
      });
    },
    reportNewsfeed({ commit, state }) {
      commit('setLoadingModal', { stateName: 'report', newVal: false });
      this._vm.$MS_SOCO_PUBLIC_API_URL
        .post(`newsfeed/${state.report.newsfeedId}/reports`, {
          type: state.report.type,
        })
        .then((response) => {
          if (response.status === 200) {
            this._vm.$toasted.global.show('Report berhasil dikirim.');
          } else {
            this._vm.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
          }
          commit('setOpenModal', { stateName: 'report', newVal: false });
          commit('setLoadingModal', { stateName: 'report', newVal: true });
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 403) {
            this._vm.$toasted.global.error('Anda sudah pernah melaporkan konten ini');
          } else {
            this._vm.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
          }
          commit('setOpenModal', { stateName: 'report', newVal: false });
          commit('setLoadingModal', { stateName: 'report', newVal: true });
        });
    },
  },
  getters: {},
};
